import { TFunction } from 'i18next';

export const paymentAgreementJustdone = (t: TFunction): string =>
  t(
    'subscription:payment_form.agreement_justdone',
    'GM Appdev Limited, with registered address at Nafpliou, 15, Limassol, Cyprus, 3025',
  );
